import React, { useContext, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import { useForceRender } from '../../../hooks/useForceRender';
import { ListDialects } from '../../../CMFW/layout/ListDialects';
import Label from '../../../CMFW/input/Label';
import CATModel from '../../../models/CATModel';
import CircularProgress from '@material-ui/core/CircularProgress';
import ReadingTextModel from '../../../models/ReadingTextModel';

export type IProps = {};

const CATContextReading: React.FC<IProps> = () => {
  const forceRender = useForceRender();
  const module = useContext(ModuleContext) as CATModel;
  const readingTextModel = useMemo(() => new ReadingTextModel({ render: forceRender, courseId: module.courseId }), [
    forceRender,
    module.courseId,
  ]);

  const active = module.getActive();

  useEffect(() => {
    if (active) {
      readingTextModel.loadItemEdit(active.itemId);
    }
  }, [readingTextModel, active]);

  if (active === null) {
    return null;
  } else if (readingTextModel.loadingItem) {
    return (
      <Wrapper>
        <CircularProgress size={10} />
      </Wrapper>
    );
  } else {
    return (
      <ModuleContext.Provider value={readingTextModel}>
        <Wrapper>
          <ListDialects keyName={'sources'} narrow>
            <Label keyName={'text'} />
          </ListDialects>
        </Wrapper>
      </ModuleContext.Provider>
    );
  }
};

export default CATContextReading;

const Wrapper = styled.div`
  margin: 4px;
  font-size: 14px !important;
  white-space: pre-wrap;
`;

const Info = styled.p`
  margin: 0;
`;
